import { get, post } from "../../../../shared/data";

export const getOptions = (cxhParentId) => {
    const childPath = cxhParentId ? `/${cxhParentId}` : "";

    return get(`/cxhtaxonomy${childPath}`);
};

export const mapSelection = (selected) => {
    return !selected
        ? ""
        : {
              value: selected.cxHId,
              text: selected.description,
              code: selected.cxHId,
          };
};

const mapSelections = (selections, cxHId, sel) => {
    if (sel.length !== 1 && !sel[0]) {
        return selections;
    }

    if (sel[0].description !== "Root") {
        selections.push({ ...sel[0] });
    }

    if (sel[0].cxHId !== cxHId && sel[0].children) {
        mapSelections(selections, cxHId, sel[0].children);
    }

    return selections;
};

export const mapSelectionText = (selections) => {
    const selectionsText = selections.map((sel) => {
        return sel.description;
    });

    return selectionsText.join(" > ");
};

export const getHierarchy = (cxHId) => {
    return get(`/cxhtaxonomy/${cxHId}/hierarchy`).then((response) => {
        if (!response) {
            return [];
        }

        return response.treeRoot ? mapSelections([], cxHId, response.treeRoot) : [];
    });
};

export const searchTaxonomy = (term) => {
    const payload = {
        searchString: term,
        ignorePunctuation: true,
    };

    return post("/cxhtaxonomy/search", payload, { defaultReturn: [] });
};

export const getUserHistory = (userEmail) => {
    return get(`/cxhtaxonomy/history/user?userEmail=${userEmail}`, { defaultReturn: [] });
};
